<template>
  <div class="IncomeList_vue">

    <button id="income_g-last" @click="$tours['incomeUploadsGuide'].start()" class="startGuideBtn"><i
        class="fal fa-question-circle"></i></button>
    <v-tour
        name="incomeUploadsGuide"
        :steps="steps"
        :options="tourOptions"
        :callbacks="tourCallbacks"
    ></v-tour>

    <b-container fluid class="mt-3 px-0">
      <b-row>
        <b-col cols="12">
          <div class="d-flex justify-content-between">
            <div class="d-flex justify-content-between w-100">
              <div class="position-absolute pt-2 pl-3 search-icon" v-if="noFilterTotalCount > 0">
                <i class="fas fa-search"></i>
              </div>
              <div v-if="noFilterTotalCount > 0" id="income_g1" class="w-75 w-md-50">
                <b-form-input
                    debounce="600"
                    v-model="searchTerm"
                    class=" search-bar mb-0"
                    :placeholder="$cte('income.searchPlaceholder')"
                    style="padding-left: 45px !important;"
                >
                </b-form-input>
              </div>
              <div v-else class="w-100"></div>
              <b-button
                  id="income_g2"
                  variant="primary"
                  class="d-flex align-items-center justify-content-center py-0 py-sm-1"
                  @click="goToFileUpload('INCOME')"
              >
                <i class="fa fa-plus d-sm-none"></i>
                <span class="d-none d-md-inline-block mt-1">{{
                    $cte("income.newInvoice")
                  }}</span>
              </b-button>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <InvoiceView
        detail-view="/app/income"
        :search-term="searchTerm"
        state-id="InvoiceView-Income"
        type="INCOME"
        @noFilterLoad="data => noFilterTotalCount = data"
    />

  </div>
</template>

<script>
import InvoiceView from "@/components/InvoiceView";

export default {
  name: "IncomeList",
  components: {
    InvoiceView,
  },
  data() {
    return {
      searchTerm: '',
      noFilterTotalCount: 0,
      tourOptions: {
        useKeyboardNavigation: true,
        highlight: true,
        labels: {
          buttonSkip: 'x',
          buttonPrevious: '<',
          buttonNext: '>',
          buttonStop: 'x'
        },
      },
      steps: [
        {
          target: '#income_g1',
          content: 'Itt kereshetsz a korábban feltöltött fájlok nevére',
          offset: -80,
          params: {
            highlight: true,
            placement: 'bottom',
          }
        },
        {
          target: '#income_g2',
          content: 'A “feltöltés” gombra kattintva tudod a számláidat feltölteni.',
          offset: -80,
          params: {
            highlight: true,
            placement: 'bottom',
          }
        },
        {
          target: '#g3',
          content: 'A feltöltött számláid listáját itt találod.',
          offset: -80,
          params: {
            highlight: true,
            placement: 'bottom',
          }
        },
        {
          target: '#g4',
          content: 'A feltöltött számláid részleteit a számlaösszesítőben tekintheted meg',
          offset: -80,
          params: {
            highlight: true,
            placement: 'bottom',
          }
        },
        {
          target: '#g-last',
          content: 'Ha segítségre van szükséged ezt súgót bármikor elérheted az ikonra kattintva.',
          offset: -80,
          params: {
            highlight: true,
            placement: 'bottom',
          }
        }
      ]
    }
  },

  async mounted() {
    if (!document.cookie.includes('incomeUploadsGuideDisabled=true')) {
      this.$tours['incomeUploadsGuide'].start();
    }
  },

  computed: {
    tourCallbacks() {
      return {
        onSkip: this.onTourFinish,
        onStop: this.onTourFinish,
        onFinish: this.onTourFinish,
      };
    },
  },

  methods: {

    goToFileUpload(resourceType) {
      this.$router.push({
        path: "/app/incomes/fileUpload",
        query: {resourceType},
      });
    },

    onTourFinish() {
      const d = new Date();
      d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
      let expires = "expires=" + d.toUTCString();
      document.cookie = "incomeUploadsGuideDisabled=true;" + expires + ";path=/";
    }
  },
};
</script>

<style scoped>
.search-icon {
  color: gray;
  font-size: 1.3rem;
}

.search-bar {
  color: #000000 !important;
  background-color: #ffffff !important;
  border: 1px solid rgb(222, 226, 230) !important;
}

.startGuideBtn {
  position: relative;
  top: -132px;
  right: 50px;
  float: right;
  cursor: pointer;
  color: #252734;
  background-color: transparent;
  border-radius: 32px;
  border: none;
  width: 40px;
  height: 40px;
  z-index: 1050;
}

::v-deep .v-step__content {
  padding: 10px;
}

::v-deep .v-step {
  background-color: white !important;
  border-radius: 24px !important;
  border: 1px solid #B6C3C8;
  color: #202020;
}

::v-deep .v-step__buttons {
  text-align: right;
}

::v-deep .v-step__button {
  color: #202020 !important;
  border-radius: 24px !important;
  border: 1px solid #B6C3C8;
  padding: 0px 10px !important;
  font-size: 16px;
  width: 36px;
  height: 36px;
}

::v-deep .v-step__arrow {
  display: none;
}

::v-deep .v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(255, 255, 255, .9) !important;
  border-radius: 28px;
}
</style>
